import React, { useState, useCallback, memo } from "react";

const Delete = memo(({ handleDeleteEvent }) => {
	const [isOptionsVisible, setOptionsVisible] = useState(false);
	
	const handleToggleOptions = useCallback(() => {
		setOptionsVisible(!isOptionsVisible);
	}, [isOptionsVisible]);
	
	const buttonClasses = `font-light hover:bg-red-500 text-white flex-1 bg-red-400 h-full uppercase`;
	const transitionClasses = `text-center transition-[opacity,transform] duration-200 ease-in-out`;
	
	return (
		<div className="relative overflow-hidden">
			<div
				onClick={!isOptionsVisible ? handleToggleOptions : undefined}
				className={`w-full relative flex items-center uppercase border-2 border-black rounded-md bg-red-400 border-solid font-semibold text-sm sm:text-base text-white transition duration-300 ease-in-out h-10 ${
					!isOptionsVisible && "cursor-pointer hover:bg-red-500"
				}`}
			>
				<div className={`${transitionClasses} flex justify-center items-center font-light ${
					isOptionsVisible
						? "opacity-0 translate-x-full w-0 h-0"
						: "opacity-100 -translate-x-0 w-full h-full"
				}`}>
					Cancel Reservation
				</div>
				<div className={`${transitionClasses} ${
					isOptionsVisible
						? "opacity-100 translate-x-0 w-full h-full"
						: "opacity-0 -translate-x-full w-0 h-0"
				}`}>
					<div className="flex justify-between uppercase h-full items-center">
						<button onClick={handleDeleteEvent} className={`${buttonClasses} rounded-md`}>Yes</button>
						<div className="flex-1 bg-white uppercase text-black flex h-full justify-center items-center text-sm px-4 font-light">Are you sure?</div>
						<button onClick={handleToggleOptions} className={`${buttonClasses} cursor-pointer rounded-md`}>No</button>
					</div>
				</div>
			</div>
		</div>
	);
});

export default Delete;
